import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useKTable} from '../../../../../../contexts/KTableProvider'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import InputDate from '../../../../../../components/UI/Input/inputDate'
import {orderGenerateLaundryBatch} from '../../../../schema/laundryBatch'
import {useLaundryFilter} from '../../../../hooks/useLaundryFilter'
import {filterLaundryBatchModel} from '../../../../model'
import {useCamp, useClient, useSite, useCompany} from '../../../../../central/hooks'
import {SelectModel} from '../../../../model'
import {SelectWrapper} from '../../../../../../components/UI/Form/Input'
import useTableForMaster from '../../../../hooks/useTableForMaster'
import {LavadoCompania, LavadoExterno, Salida} from '../Modal'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import useEnterpriseService from '../../../../../central/hooks/useEnterpriseService'
import {useSupplier} from '../../../../hooks'
type Props = {
  getLaundryList: (e: any) => void
  formValues: any
  setFormValues: Dispatch<SetStateAction<any>>
  formValueLoading: any
  setFormValueLoading: Dispatch<SetStateAction<any>>
}
export const FormLaundryBatch: FC<Props> = ({
  getLaundryList,
  formValues,
  setFormValues,
  formValueLoading,
  setFormValueLoading,
}) => {
  const {selectedLav, clearSelected, setData, data} = useKTable()
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const {getSupplierList, supplierList} = useSupplier()
  const [searching, setIsSearching] = useState<boolean>(false)
  const [company, setCompany] = useState<SelectModel[]>([])
  const [clients, setClients] = useState<SelectModel[] | any>([])
  const [sites, setSites] = useState<SelectModel[] | any>([])
  const [camps, setCamps] = useState<SelectModel[]>([])
  const [process, setProcess] = useState<SelectModel[]>([])
  const [showCompany, setShowCompany] = useState(false)
  const [showExterno, setShowExterno] = useState(false)
  const [showOut, setShowOut] = useState(false)
  const methods = useForm({
    resolver: yupResolver(orderGenerateLaundryBatch),
  })

  const {
    formState: {errors},
    register,
    setValue,
    watch,
    handleSubmit,
    setError,
    reset,
  } = methods

  const {laundryPoint, getLaundryPointList, getContratist, getWashedOrderStatus} =
    useLaundryFilter()
  const {
    typeProcessLaundry,
    getTypeProcessLaundryList,
    typeAdmin,
    getTypeAdminList,
    typeGuest,
    getTypeGuestList,
    typeGuestStay,
    getTypeGuestStayList,
    typeLaundryOrderLote,
    getTypeLaundryLoteList,
    setTypeProcessLaundry,
  } = useTableForMaster()
  const {enterPriseByOrders, getEnterpriseByOrderList} = useEnterpriseService()

  const {getCompanyFD} = useCompany()
  const {getClientFD} = useClient()
  const {getSiteFD} = useSite()
  const {getCampFD} = useCamp()
  const getCompanyList = async () => {
    const response = await getCompanyFD({})
    if (response.length === 1) {
      setValue('companiaId', response[0].value)
      setError('companiaId', {})
      await getClientList(response[0].value as string)
    }

    setCompany(response)
  }
  const getClientList = async (companyId: string) => {
    const response = await getClientFD({companiaId: companyId})
    if (response.length === 1) {
      setValue('clienteId', response[0].value)
      setError('clienteId', {})
      await getSiteList(response[0].value as string)
    }
    setClients(response)
  }
  const getSiteList = async (clientId: string) => {
    const response = await getSiteFD({clienteId: clientId})
    if (response.length === 1) {
      setValue('siteId', response[0].value)
      setError('siteId', {})
      await getCampList(response[0].value as string)
      await getLaundryPointList({siteId: response[0].value})
    }
    setSites(response)
  }
  const getCampList = async (siteId: string) => {
    const response = await getCampFD({siteId: siteId})
    if (response.length === 1) {
      setValue('campamentoId', response[0].value)
      setError('campamentoId', {})
    }
    setCamps(response)
  }

  const handleFilterClient = (e: any) => {
    let value = e.value
    getClientList(value)
    setValue('companiaId', value)
    setError('companiaId', {})
  }

  const handleFilterSite = (e: any) => {
    let value = e.value
    getSiteList(value)
    setValue('clienteId', value)
    setError('clienteId', {})
  }

  const handleFilterCamp = async (e: any) => {
    let value = e.value
    getCampList(value)
    await getLaundryPointList({siteId: value})
    setValue('siteId', value)
    setError('siteId', {})
  }

  const handleFilterLaundryPoint = (e: any) => {
    let value = e.value
    setValue('campamentoId', value)
    setError('campamentoId', {})
  }

  const onSubmit = (dataForm: filterLaundryBatchModel) => {
    try {
      setIsSearching(true)
      const {fechaRecepcion: inicio} = dataForm
      const data = {
        ...dataForm,
        fechaRecepcion: inicio ? new Date(inicio) : '',
      }
      setFormValues(data)
      setFormValueLoading(true)
      setIsSearching(false)
      clearSelected()
    } catch (error) {
      setIsSearching(false)
    }
  }

  const handleResetForm = () => {
    reset()
    setData([])
  }

  useEffect(() => {
    getCompanyList()
    getContratist()
    getWashedOrderStatus()
    getTypeProcessLaundryList()
    getTypeAdminList()
    getTypeGuestList()
    getTypeGuestStayList()
    getEnterpriseByOrderList()
    getSupplierList()
    getTypeLaundryLoteList()
  }, [])

  const handleOpenModalProcess = () => {
    if (currentTabItem.typeProcess === 'LAVADO') {
      switch (currentTabItem.typeAdmin) {
        case 'COMPAÑÍA':
          setShowCompany(true)
          break
        case 'EXTERNO':
          setShowExterno(true)
          break
        default:
          setShowCompany(true)
          break
      }
    }
    if (currentTabItem.typeProcess === 'SALIDA') {
      setShowOut(true)
    }
  }
  const handleGetTypeProccess = (e: any) => {
    let value = e.value
    changeCurrentTabItem({
      ...currentTabItem,
      typeProcess: value,
    })
  }
  const handleGetTypeProccesOrder = (e: any) => {
    if (e.value === 'LOTECAMA') {
      let temp = typeProcessLaundry.filter((item) => item.value === 'LAVADO')

      setProcess(temp)
    } else {
      setProcess(typeProcessLaundry)
    }
  }

  const handleGetTpyeAdmin = (e: any) => {
    let value = e.value
    setValue('tipoAdministracion', value)
    setError('tipoAdministracion', {})
    changeCurrentTabItem({
      ...currentTabItem,
      typeAdmin: value,
    })
    if (value === 'EXTERNO') {
      setValue('puntoId', '')
      setError('puntoId', {})
    } else {
      setValue('proveedorId', '')
      setError('proveedorId', {})
    }
  }

  return (
    <div className='p-6'>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className='m-2'>
          <div className='row'>
            <div className='col-sm-12 col-lg-3'>
              <SelectWrapper
                labelText='Compañía'
                name='companiaId'
                data={company}
                onChangeValue={handleFilterClient}
                required
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <SelectWrapper
                labelText='Cliente'
                disabled={clients.length === 0}
                name='clienteId'
                data={clients}
                onChangeValue={handleFilterSite}
                required
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <SelectWrapper
                labelText='Site'
                name='siteId'
                data={sites}
                disabled={sites.length === 0}
                onChangeValue={handleFilterCamp}
                required
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <SelectWrapper
                labelText='Campamento'
                name='campamentoId'
                data={camps}
                disabled={camps.length === 0}
                onChangeValue={handleFilterLaundryPoint}
                required
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <SelectWrapper
                labelText='Tipo de orden'
                disabled={typeLaundryOrderLote.length === 0}
                name='tipoLavado'
                data={typeLaundryOrderLote}
                required
                onChangeValue={handleGetTypeProccesOrder}
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <SelectWrapper
                labelText='Tipo de proceso'
                disabled={process.length === 0}
                name='tipoProceso'
                data={process}
                required
                onChangeValue={handleGetTypeProccess}
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <SelectWrapper
                labelText='Tipo de administración'
                disabled={typeAdmin.length === 0}
                name='tipoAdministracion'
                data={typeAdmin}
                onChangeValue={handleGetTpyeAdmin}
                required
              />
            </div>
            {watch('tipoAdministracion') === 'COMPAÑÍA' && (
              <div className='col-sm-12 col-lg-3'>
                <SelectWrapper
                  labelText='Puntos de Lavandería'
                  disabled={laundryPoint.length === 0}
                  name='puntoId'
                  data={laundryPoint}
                />
              </div>
            )}
            {watch('tipoAdministracion') === 'EXTERNO' && (
              <div className='col-sm-12 col-lg-3'>
                <SelectWrapper
                  labelText='Proveedor'
                  disabled={supplierList.length === 0}
                  name='proveedorId'
                  data={supplierList}
                />
              </div>
            )}
            <div className='col-sm-12 col-lg-3'>
              <label>Fecha Recepción de Orden Lavado:</label>
              <InputDate name='fechaRecepcion' register={register} errors={errors} />
            </div>
            {watch('tipoLavado') === 'LOTEHUESPED' && (
              <>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Tipo Huésped'
                    disabled={typeGuest.length === 0}
                    name='tipoHuesped'
                    data={typeGuest}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Tipo Estadía'
                    disabled={typeGuestStay.length === 0}
                    name='tipoEstadia'
                    data={typeGuestStay}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <SelectWrapper
                    labelText='Empresa Subcontratista'
                    disabled={enterPriseByOrders.length === 0}
                    name='empresa'
                    data={enterPriseByOrders}
                  />
                </div>
              </>
            )}
          </div>
          <ButtonWrapper className='sdx-white-bg overflow-visible justify-content-end'>
            <Button label='Buscar' loading={searching} typeBtn='submit' />
            <Button label='Limpiar' onClick={() => handleResetForm()} />
            <Button
              label='Procesar'
              typeBtn='button'
              disabled={selectedLav.length === 0}
              onClick={handleOpenModalProcess}
            />
          </ButtonWrapper>
        </form>
      </FormProvider>
      {showCompany && (
        <LavadoCompania
          setShow={setShowCompany}
          show={showCompany}
          data={selectedLav}
          tipoLavado={watch('tipoLavado')}
        />
      )}
      {showExterno && (
        <LavadoExterno
          setShow={setShowExterno}
          show={showExterno}
          data={selectedLav}
          tipoLavado={watch('tipoLavado')}
        />
      )}
      {showOut && (
        <Salida setShow={setShowOut} show={showOut} data={selectedLav} dataTable={data} />
      )}
    </div>
  )
}
